module.exports = __webpack_public_path__ + "img/mall07.2c078bbd.png";